import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import { Toaster } from "./components/ui/sonner";
import LandingPage from "./pages/LandingPage";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import DashboardPage from "./pages/DashboardPage";
import ProjectsListPage from "./pages/ProjectsListPage";
import NewProjectPage from "./pages/NewProjectPage";
import ProjectWorkspacePage from "./pages/ProjectWorkspacePage";
import TokenPurchasePage from "./pages/TokenPurchasePage";
import AdminPage from "./pages/AdminPage";
import LogsPage from "./pages/LogsPage";
import VSCodePage from "./pages/VSCodePage";
import SettingsPage from "./pages/SettingsPage";

import { BarShimmerLoader } from "./components/ModernLoader";

function ProtectedRoute({ children, adminOnly = false }) {
  const { user, loading } = useAuth();
  if (loading) return (
    <div className="min-h-screen bg-[var(--surface-bg,#050505)] flex items-center justify-center">
      <BarShimmerLoader />
    </div>
  );
  if (!user) return <Navigate to="/login" />;
  if (adminOnly && !user.is_admin) return <Navigate to="/dashboard" />;
  return children;
}

function PublicRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (user) return <Navigate to="/dashboard" />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<PublicRoute><LandingPage /></PublicRoute>} />
          <Route path="/login" element={<PublicRoute><LoginPage /></PublicRoute>} />
          <Route path="/register" element={<PublicRoute><RegisterPage /></PublicRoute>} />
          <Route path="/dashboard" element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
          <Route path="/projects" element={<ProtectedRoute><ProjectsListPage /></ProtectedRoute>} />
          <Route path="/new-project" element={<ProtectedRoute><NewProjectPage /></ProtectedRoute>} />
          <Route path="/project/:id" element={<ProtectedRoute><ProjectWorkspacePage /></ProtectedRoute>} />
          <Route path="/tokens" element={<ProtectedRoute><TokenPurchasePage /></ProtectedRoute>} />
          <Route path="/admin" element={<ProtectedRoute adminOnly><AdminPage /></ProtectedRoute>} />
          <Route path="/logs" element={<ProtectedRoute><LogsPage /></ProtectedRoute>} />
          <Route path="/vscode" element={<ProtectedRoute><VSCodePage /></ProtectedRoute>} />
          <Route path="/settings" element={<ProtectedRoute><SettingsPage /></ProtectedRoute>} />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="dark" position="top-right" />
    </AuthProvider>
  );
}

export default App;
